import script from "./AppAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppAvatar.vue?vue&type=script&setup=true&lang=js"

import "./AppAvatar.vue?vue&type=style&index=0&id=3cbc4cb2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cbc4cb2"]])

export default __exports__